import React from 'react'

import AddTypeForm from '../../modules/Type/components/AddTypeForm'
export default function AddTypePage() {
  return <AddTypeForm />
}
